import { CookieStorage, Keycloak } from '@unitedtraders/keycloak';
import { getLogger } from 'loglevel';
import { Model } from 'nestedtypes';
import { getDomain } from '../utils/domain';

const AuthenticatedState = Model.extend({
  defaults: {
    isAuthenticated: Boolean.value(false)
  }
});

const UserInfo = Model.extend({
  defaults: {
    accessToken: String.value(null),
    user_id: Number.value(null),
    roles: String.Collection
  }
});

export class KeycloakAuthorization {
  constructor(tokens, settings) {
    const storage = new CookieStorage(
      {
        domain: getDomain(),
        accessTokenName: 'access_token',
        refreshTokenName: 'refresh_token'
      },
      getLogger('SessionServiceCookieStorage')
    );

    this.keycloak = new Keycloak(
      settings,
      tokens && tokens.accessToken
        ? {
            access_token: tokens.accessToken,
            refresh_token: tokens.refreshToken
          }
        : undefined,
      storage
    );

    this.authenticatedState = new AuthenticatedState();
    this.userInfo = new UserInfo();

    this.keycloak.on('remove:tokens', () => {
      this.setUserInfo();
      this.authenticatedState.set({ isAuthenticated: false });
    });

    this.keycloak.on('change:tokens', tokens => {
      this.setUserInfo(tokens);
      this.authenticatedState.set({ isAuthenticated: true });
    });

    this.keycloak
      .getTokens()
      .then(tokens => {
        this.setUserInfo(tokens);
        this.authenticatedState.set({ isAuthenticated: true });
      })
      .catch(() => null);

    this.keycloak.startAutoRefresher();
  }

  setUserInfo(tokens) {
    if (tokens && tokens.parsedAccessToken) {
      return this.userInfo.set({
        user_id: tokens.parsedAccessToken.user_id,
        roles: tokens.parsedAccessToken.realm_access.roles,
        accessToken: tokens.accessToken
      });
    }
    this.userInfo.set({
      user_id: null,
      roles: [],
      accessToken: null
    });
  }

  getTokens() {
    return this.keycloak.getTokens();
  }

  setTokens(tokens) {
    this.keycloak.setTokens(tokens);
  }

  logout() {
    return this.keycloak.logout();
  }

  getAuthorizationPromise() {
    return this.keycloak.getTokens().catch(() => null);
  }

  getAuthorizationHeaderValue() {
    return this.keycloak
      .getTokens()
      .then(tokens => (tokens ? `Bearer ${tokens.accessToken}` : null))
      .catch(() => '');
  }

  getAuthenticationState() {
    return this.authenticatedState;
  }

  isAuthenticated() {
    return this.authenticatedState.isAuthenticated;
  }

  getAccessToken() {
    return this.userInfo.accessToken;
  }

  getUserInfo() {
    return this.userInfo;
  }

  hasRole(role) {
    const roleName = typeof role === 'object' ? role.name : role;
    return this.userInfo.roles && this.userInfo.roles.includes(roleName);
  }
}



// WEBPACK FOOTER //
// ./src/services/KeycloakAuthorization.js